"use client";

import Link from "next/link";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <hr />
      <footer className="container mx-auto px-4 md:px-8 py-3">
        <div className="container py-4">
          <div className="flex flex-col gap-4">
            {/* Anchor Navigation */}
            <nav className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-muted-foreground">
              <Link
                href="#cijfer-berekenen"
                className="hover:text-foreground transition-colors"
              >
                Cijfer berekenen
              </Link>
              <Link
                href="#cesuur"
                className="hover:text-foreground transition-colors"
              >
                Cesuur
              </Link>
              <Link
                href="#normering"
                className="hover:text-foreground transition-colors"
              >
                Normering
              </Link>
              <Link
                href="#cijfertabel"
                className="hover:text-foreground transition-colors"
              >
                Cijfertabel
              </Link>
              <Link
                href="#welk-cijfer"
                className="hover:text-foreground transition-colors"
              >
                Score opzoeken
              </Link>
              <Link
                href="#faq"
                className="hover:text-foreground transition-colors"
              >
                FAQ
              </Link>
              <Link
                href="#support"
                className="hover:text-foreground transition-colors"
              >
                Steun ons
              </Link>
            </nav>

            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <nav className="flex items-center gap-4 text-sm text-muted-foreground">
                <Link
                  href="/"
                  className="font-medium hover:text-foreground transition-colors"
                >
                  Home
                </Link>
                <Link
                  href="/algemene-voorwaarden"
                  className="font-medium hover:text-foreground transition-colors"
                >
                  Algemene Voorwaarden
                </Link>
                <a
                  href="https://berekencijfers.featurebase.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-medium hover:text-foreground transition-colors"
                >
                  Feedback
                </a>
              </nav>
              <div className="text-sm text-muted-foreground">
                © {currentYear} Joeghanoe Bhatti. Alle rechten voorbehouden.
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
